exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oda-form[data-v-86bf1a5a]{margin-bottom:20px;padding:10px;border:1px solid #ccc;border-radius:5px}", ""]);

// exports
